import { List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { EEntityType, entityTypeToLink } from '@sharedInterfaces/globalEnums';
import { EDashboardWidgetTypes, type IDashboardWidgetProps } from '@sharedInterfaces/IDashboard';
import { EmployeePicture } from '@src/App/Components/General/EmployeePicture/EmployeePicture';
import EmployeesInput from '@src/App/Components/General/FormularElements/formsControls/inputs/EmployeesInput/EmployeesInput';
import type { TWidgetDefinition } from '@src/App/Pages/DashboardPage/Dashboard/Dashboard';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import styles from './PersonListDashboardWidget.module.css';

const PersonListDashboardWidget: React.FC<IDashboardWidgetProps<EDashboardWidgetTypes.personListWidget>> = ({
    id,
    params,
    isEditing,
    onParamChange,
}) => {
    const navigate = useNavigate();
    const allEmployees = useSelector((state: AppState) => state.company.allEmployees);
    const employeeIds = params.employeeIds;
    const selectedEmployees = allEmployees.filter((e) => employeeIds.includes(e.id));
    if (isEditing)
        return (
            <EmployeesInput
                allEmployees={allEmployees}
                selectedEmployees={selectedEmployees}
                className={styles.input}
                size="medium"
                showMode={false}
                onChange={(employees) =>
                    onParamChange(
                        id,
                        'employeeIds',
                        employees.map((e) => e.id),
                    )
                }
            />
        );

    return (
        <List>
            {selectedEmployees.map((e) => {
                const nameSplit = e.title.split(' ');
                const firstName = nameSplit.length > 0 ? nameSplit[0] : '';
                const lastName = nameSplit.length > 1 ? nameSplit[nameSplit.length - 1] : '';

                return (
                    <ListItem key={e.id}>
                        <ListItemAvatar>
                            <EmployeePicture
                                avatarSize={45}
                                openDialogOnClick={true}
                                employee={{
                                    firstName: firstName,
                                    lastName: lastName,
                                    pictureId: e.pictureId,
                                    id: e.id,
                                }}
                            />
                        </ListItemAvatar>
                        <ListItemText
                            onClick={() => navigate(entityTypeToLink(e.id, EEntityType.EMPLOYEE))}
                            style={{ cursor: 'pointer' }}
                        >
                            {e.title}
                        </ListItemText>
                    </ListItem>
                );
            })}
        </List>
    );
};

export const personListDashBoardWidgetDefinition = {
    type: EDashboardWidgetTypes.personListWidget,
    render: PersonListDashboardWidget,
    overrideCardDesign: false,
    defaultParams: { employeeIds: [] },
} satisfies TWidgetDefinition;
